import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';

export const REFRESH_EVENT_DATA = gql`
  mutation RefreshEventData($input: EventRefreshInput!) {
    eventRefresh(input: $input) {
      errors {
        ...ErrorFields
      }
      entity
    }
  }
  ${ErrorFragment}
`;

export const REFRESH_FIELD_DATA = gql`
  mutation RefreshFieldData($input: FieldRefreshInput!) {
    fieldRefresh(input: $input) {
      errors {
        ...ErrorFields
      }
      entity
    }
  }
  ${ErrorFragment}
`;
